<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="100%">
      <v-card>
        <v-card-title class="title grey lighten-2 py-0" primary-title>
          Vincular Projetos
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-2"
            v-model="search"
            append-icon="search"
            clearable
          ></v-text-field>
          <v-tooltip bottom>
            <v-btn
              flat fab small icon
              slot="activator"
              :loading="loading"
              @click="$emit('atualizaListaProjetosVincular')">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              color="primary"
              fab dark small
              :loading="loading"
              @click="vinculaProjeto">
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="projetos"
            item-key="IdProjeto"
            class="elevation-1"
            rows-per-page-text="Registros"
            select-all
            :pagination.sync="defaultPagConfig"
            :loading="loading"
            :search="search"
            no-data-text="Nenhum registro encontrado"
          >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:items="props">
              <tr
                :active="props.selected"
                class="cursor-pointer"
                @click="props.selected = !props.selected"
              >
                <td>
                  <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
                </td>
                <td v-for="(header, index) in headers" :key="index">
                  <v-avatar v-if="header.value === 'Status'" size="32" :color="statusCor(props.item.Status)">
                    <span class="white--text">{{ props.item.Status[0] }}</span>
                  </v-avatar>
                  <v-avatar v-if="header.value === 'Cor'" size="32" :color="props.item.Cor" />
                  <v-progress-circular
                    v-if="header.value === 'ValorGut'"
                    :size="36"
                    :value="props.item.ValorGut || 0"
                    :color="matrizGutColor(props.item.ValorGut || 0)"
                  >
                    <span class="font-weight-medium">{{ props.item.ValorGut || 0 }}</span>
                  </v-progress-circular>
                  <v-progress-circular
                    v-if="header.value === 'ValorNps' && props.item.ValorNps !== null && props.item.ValorNps !== undefined"
                    :size="36"
                    :value="npsValue(props.item.ValorNps)"
                    :color="npsColor(props.item.ValorNps)"
                  >
                    <span class="font-weight-medium">{{ props.item.ValorNps }}</span>
                  </v-progress-circular>
                  <span v-if="filtraHeaders(header)">{{ props.item[header.value] }}</span>
                </td>
              </tr>
            </template>
            <template v-slot:no-results>
              <v-alert
                :value="true"
                color="error"
                icon="warning"
              >Pesquisa por "{{ search }}" não encontrou resultados.</v-alert>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';

export default {
  name: 'ModalListProjeto',
  props: ["value", "loading"],
  data: () => ({
    selected: [],
    search: '',
    defaultPagConfig: {
      descending: false,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "Descricao"
    },
    headers: [
      { text: "ID", value: "IdProjeto" },
      { text: "Descrição", value: "Projeto" },
      { text: "Cliente", value: "Cliente" },
      { text: "Tipo", value: "TipoProjeto" },
      { text: "Responsável", value: "Responsavel" },
      { text: "Situação", value: "Situacao" },
      { text: "Status", value: "Status" },
      { text: "GUT", value: "ValorGut" },
      { text: "NPS", value: "ValorNps" },
    ],
    customHeaders: ["Status", "ValorGut", "ValorNps"],
  }),
  computed: {
    ...mapGetters(["projetos"])
  },
  methods: {
    vinculaProjeto() {
      this.$emit('vinculaProjeto', this.selected);
      this.selected = [];
    },
    filtraHeaders(header) {
      return !this.customHeaders.includes(header.value);
    },

    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },

    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },

    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },

    statusCor(status) {
      if (status.startsWith('A')) return "#263238";
      if (status.startsWith('P')) return "#263238";
      if (status.startsWith('F')) return "#1976d2";
      if (status.startsWith('C')) return "#bdbdbd";
    },
  }
};
</script>

<style>
</style>
